import { Rollout as PortableRollout, type RolloutData } from '@gonfalon/legacy-migration-ui/rollout-view';
import type { schemas } from '@gonfalon/openapi/types';

import type { Rollout as RolloutRecord } from '#utils/flags/records/Rollout';

type Variation = schemas['Variation'];
type VariationWithTooltip = Variation & { tooltip?: string };

export interface RolloutProps {
  variations: VariationWithTooltip[];
  stageCount: number;
  rollout?: RolloutRecord;
}

/**
 * Legacy-side adapter that converts the Immutable `Rollout` Record into the
 * portable component's plain `RolloutData` shape and forwards. Lets static/ld
 * call sites keep their existing import path and Immutable prop while the
 * package owns the rendering.
 */
export function Rollout({ variations, stageCount, rollout }: RolloutProps) {
  const portableRollout: RolloutData | undefined = rollout
    ? {
        weights: variations.map((_, i) => rollout.getWeightForIndex(i)),
        contextKind: rollout.getContextKind(),
        bucketBy: rollout.bucketBy,
      }
    : undefined;

  return <PortableRollout variations={variations} stageCount={stageCount as 2 | 4 | 6} rollout={portableRollout} />;
}
